import { render } from "./HtmlContent.vue?vue&type=template&id=53a9188a"
import script from "./HtmlContent.vue?vue&type=script&lang=js"
export * from "./HtmlContent.vue?vue&type=script&lang=js"

import "./HtmlContent.vue?vue&type=style&index=0&id=53a9188a&lang=css"

import exportComponent from "/Volumes/TRENTDEVELOPMENT/www/classmarker_pre_release_production/web_apps/test-interface/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__